module.exports = __webpack_public_path__ + "img/modal-document-null.8adf5c0b.svg";